import React from 'react';
import { useIdentificationContext } from '@fiverr-private/identification_core';
import { useExperiment } from '../../shared/hooks/useExperiment';
import { Experiments } from '../../shared/constants/experiments';
import { useStepsContext } from '../StepsContext';
import { BlockedActionBanner } from './BlockedActionBanner';
import { BriefAndMatchBanner } from './BriefAndMatchBanner';
import { DefaultIllustrationBanner } from './DefaultIllustrationBanner';
import { WithActivationIllustration } from './WithActivationIllustration';
import { WithBubblesIllustration } from './WithBubblesIllustration';

export const Banner = () => {
    const { blockedActionType } = useIdentificationContext();

    const { inGroupB: inContextualIndentificationFlowExp } = useExperiment(
        Experiments.SPIDERS_CONTEXTUAL_IDENTIFICATION_FLOW
    );
    const { inGroupB: inCtxRegBriefAndMatchExp } = useExperiment(Experiments.SPIDERS_CTX_REG_BRIEF_AND_MATCH);

    const { activeStepId } = useStepsContext();

    if (inCtxRegBriefAndMatchExp && blockedActionType === 'new_brief_and_match') {
        return <BriefAndMatchBanner />;
    }
    if (inContextualIndentificationFlowExp && blockedActionType && blockedActionType !== 'new_brief_and_match') {
        return <BlockedActionBanner blockedActionType={blockedActionType} />;
    }

    switch (activeStepId) {
        case 'code_activation':
            return <WithActivationIllustration />;
        case 'profile_setup':
            return <WithBubblesIllustration />;
        default:
            return <DefaultIllustrationBanner />;
    }
};
